export default {
	path: '/danger-warn-work-occur',
	redirect: '/danger-warn-work-occur',
	component: () => import('@/views/layout/Default'),
	children: [
		{
			path: '/',
			name: 'DangerWarnWorkOccurHome',
			component: () => import('@/views/biz/DangerWarnWorkOccur'),
		},
	],
};
